export default __webpack_public_path__ + "static/spot-neutral__hormone-free-01-089766e47348db4989087b522fec182e.jpg";